import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_ID;
const TAG_ID = process.env.REACT_APP_GOOGLE_TAG_ID;
const PURCHASE_LABEL = process.env.REACT_APP_GADS_PURCHASE_LABEL;
const GIFT_LABEL = process.env.REACT_APP_GADS_GIFT_LABEL || PURCHASE_LABEL;
const ready = () => typeof window !== "undefined" && typeof window.gtag === "function";

// The Google tag itself is loaded once in public/index.html; GA4 is just an extra destination.
if (GA_ID && ready()) window.gtag("config", GA_ID, { send_page_view: false });

export const track = (event, params = {}) => { if (ready()) window.gtag("event", event, params); };

// GTM-readable event (gtag() calls aren't visible to Tag Manager triggers).
const pushEvent = (event, data = {}) => {
  window.dataLayer = window.dataLayer || [];
  if (data.ecommerce) window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event, ...data });
};

const once = (key) => {
  try {
    if (localStorage.getItem(key)) return false;
    localStorage.setItem(key, "1");
  } catch { /* storage blocked – still send */ }
  return true;
};

const sale = (kind, label, { transaction_id, value, currency = "EUR", items = [] }) => {
  if (!once(`ss_conv_${transaction_id}`)) return;
  const ecommerce = { transaction_id, value, currency, items };
  pushEvent(kind, { ecommerce, transaction_id, value, currency });
  track("purchase", { ...ecommerce, sale_type: kind });
  if (TAG_ID && label) track("conversion", { send_to: label.includes("/") ? label : `${TAG_ID}/${label}`, transaction_id, value, currency });
};

export const trackPurchase = (p) => sale("purchase", PURCHASE_LABEL, p);
export const trackGiftPurchase = (p) => sale("gift_voucher_purchase", GIFT_LABEL, p);

const basketEvent = (event, items) => {
  const value = items.reduce((t, i) => t + i.price * i.quantity, 0);
  const ecommerce = { currency: "EUR", value, items };
  pushEvent(event, { ecommerce, value, currency: "EUR" });
  track(event, ecommerce);
};
// items: [{ item_id, item_name, item_variant, price (EUR), quantity }]
export const trackAddToCart = (items) => items.length && basketEvent("add_to_cart", items);
export const trackBeginCheckout = (items) => items.length && basketEvent("begin_checkout", items);

export const trackDesignStart = () => {
  try { if (sessionStorage.getItem("ss_design_started")) return; sessionStorage.setItem("ss_design_started", "1"); } catch { /* ignore */ }
  pushEvent("begin_design");
  track("begin_design");
};

const CONSENT_KEY = "ss_consent";
const YEAR = 365 * 24 * 3600 * 1000;

export const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
    return c && Date.now() - c.at < YEAR ? c.v : null;
  } catch { return null; }
};

export const saveConsent = (v) => {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ v, at: Date.now() }));
  if (ready()) window.gtag("consent", "update", { ad_storage: v, ad_user_data: v, ad_personalization: v, analytics_storage: v });
};

export const usePageViews = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => track("page_view", { page_path: pathname, page_title: document.title, page_location: window.location.href }), 50);
    return () => clearTimeout(t);
  }, [pathname]);
};
